import { render, staticRenderFns } from "./WorksheetsList.vue?vue&type=template&id=aefdad02"
import script from "./WorksheetsList.vue?vue&type=script&lang=js"
export * from "./WorksheetsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports